<template>
  <v-form
    ref="form"
    v-model="valid"
  >
    <div>
      <base-info-card
        :title="title"
        :subtitle="subtitle"
        space="4"
        color="primary"
      />

      <base-text-field
        v-model="name"
        label="Name"
        :rules="[v => !!v || 'Name is required']"
      />

      <base-text-field
        v-model="email"
        label="Email"
        :rules="emailRules"
      />

      <base-text-field
        v-model="subject"
        label="Subject"
      />

      <base-textarea
        v-model="body"
        class="mb-6"
        label="Your Need & Description"
      />

      <base-btn
        outlined
        target="_blank"
        @click="handleClick"
      >
        Send message
      </base-btn>
      <label
        style="padding: 50px; font-size:larger; color:#428a3b; font-weight:600;"
      >
        {{ message }}
      </label>
    </div>
  </v-form>
</template>

<script>
  export default {
    name: 'BaseContactForm',
    inject: ['theme'],

    props: {
      subtitle: String,
      title: {
        type: String,
        default: 'MAIL US YOUR MESSAGE',
      },
    },

    data: () => ({
      name: '',
      email: '',
      subject: '',
      body: '',
      valid: '',
      message: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid',
      ],
    }),

    methods: {
      handleClick: function () {
        if (this.$refs.form.validate()) {
          this.$refs.form.reset()
          this.message = 'We will contact you shortly.'
        }
      },
    },
  }
</script>
